$(document).ready(function() {

	$('.add-input').click(function(){
		var dataInputType = $(this).attr('data-input-type') || 'text';

		addInput($(this).attr('data-target'), $(this).attr('data-type'), $(this).attr('data-plural'), dataInputType);
	});

	$(document).on('click', '.remove-host, .remove-input', function(e) {
		e.preventDefault();
		removeInput(this);
	});

	function removeInput(self){
		var inputId = $(self).attr('id');
		var plural  = $(self).attr('data-plural');
        var parent = $(self).parent();

       //check if this has id ( i.e. exists in database )
        if (inputId.length) {
            //pass id through to server

            //remove input_
            var id = inputId.substr ( inputId.indexOf ( '_' ) + 1 );

            //add deleted input id to hidden fields
            var inputHtml = `<input type="hidden" name="deleted-${plural}[]" value="${id}">`;
            $('.deleted-hosts-container').append(inputHtml);

        }

		parent.hide('slow');
	}

	function addInput(target, type, plural, dataInputType){
		var html = createNewFieldHtml(type, plural, dataInputType);		
		$(target).append(html);
	}

	function createNewFieldHtml(className, plural, dataInputType){
		var html = `
            <div class="">
                <input name="${className}-new[]" type="${dataInputType}" value="">
                <a id="" class="remove-host remove-input" data-plural="${plural}">Remove</a>
            </div>`;
		return html;
	}


});


// WEBPACK FOOTER //
// ./settings.js